import { useState, useEffect } from "react";
import { navLinks } from "@/mocks/home";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="#accueil" className="h-16 block">
            <img
              src="https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/6845293c83c5fe8752674068f47ba81c.png"
              alt="Melio LM"
              className="h-full w-auto"
            />
          </a>
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-foreground-50 hover:text-primary-500 transition-colors duration-300 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-foreground-50 p-2 cursor-pointer"
              aria-label="Toggle menu"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div
        className={`md:hidden bg-background-50/95 w-full transition-all duration-300 overflow-hidden ${
          mobileMenuOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="container mx-auto px-6 py-4 flex flex-col space-y-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-foreground-50 hover:text-primary-500 transition-colors duration-300 py-2"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}